import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./mvpApproved.html";
class MvpApproved extends LightningElement {
  constructor(...args) {
    super(...args);
    this.image = void 0;
    this.imageTitle = void 0;
    this.imageCaption = void 0;
    this.mvpTitle = void 0;
    this.mvpSubtitle = void 0;
    this.mvpLink = void 0;
    this.mvpNewTab = void 0;
  }
  get hasImage() {
    return this.image?.length > 0;
  }
  get hasLink() {
    return this.mvpLink?.length > 0;
  }
  get hasImageTitle() {
    return this.imageTitle?.length > 0;
  }
  get hasImageCaption() {
    return this.imageCaption?.length > 0;
  }
  get hasMvpTitle() {
    return this.mvpTitle?.length > 0;
  }
  get hasMvpSubtitle() {
    return this.mvpSubtitle?.length > 0;
  }
  get mvpLinkTarget() {
    return this.mvpNewTab ? '_blank' : '_self';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(MvpApproved, {
  publicProps: {
    image: {
      config: 0
    },
    imageTitle: {
      config: 0
    },
    imageCaption: {
      config: 0
    },
    mvpTitle: {
      config: 0
    },
    mvpSubtitle: {
      config: 0
    },
    mvpLink: {
      config: 0
    },
    mvpNewTab: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(MvpApproved, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;